import React, { FC, memo } from 'react'
import PrevButton from 'components/PrevButton'
import { TelInputProps } from '../types'
import { useTelInput } from '../useTelInput'
import styles from './style.module.css'

const SpTelInput: FC<TelInputProps> = ({
  title,
  isOpen,
  isShowPhoneNumberPrefix = false,
  maxLengthLeft = 3,
  maxLengthCenter = 4,
  maxLengthRight = 4,
  initialValue,
  onClickEnter,
  onClickClose,
}) => {
  const {
    left,
    center,
    right,
    value,
    canClickEnter,
    onClickNumber,
    onClickBackSpace,
    onChangeLeft,
    onChangeCenter,
    onChangeRight,
  } = useTelInput({ maxLengthLeft, maxLengthCenter, maxLengthRight, initialValue })

  if (!isOpen) return null

  return (
    <div className={styles.overlay}>
      <div className={styles.modalFrame}>
        <div className={styles.prevButtonArea}>
          <PrevButton onClick={() => onClickClose(value)} />
        </div>
        <div className={styles.title}>
          <span>{title}</span>
        </div>

        <div className={styles.inputArea}>
          <input
            className={styles.input}
            type="text"
            value={left}
            maxLength={maxLengthLeft}
            onChange={onChangeLeft}
          />
          <span className={styles.separator}>-</span>
          <input
            className={styles.input}
            type="text"
            value={center}
            maxLength={maxLengthCenter}
            onChange={onChangeCenter}
          />
          <span className={styles.separator}>-</span>
          <input
            className={styles.input}
            type="text"
            value={right}
            maxLength={maxLengthRight}
            onChange={onChangeRight}
          />
        </div>

        <div className={styles.keypad}>
          {/* Phone number prefix buttons */}
          {isShowPhoneNumberPrefix && (
            <div className={styles.prefixGrid}>
              <button
                className={`${styles.button} ${value.length ? styles.prefixButtonDisabled : ''}`}
                onClick={() => onClickNumber('070')}
                disabled={!!value.length}
              >
                070
              </button>
              <button
                className={`${styles.button} ${value.length ? styles.prefixButtonDisabled : ''}`}
                onClick={() => onClickNumber('080')}
                disabled={!!value.length}
              >
                080
              </button>
              <button
                className={`${styles.button} ${value.length ? styles.prefixButtonDisabled : ''}`}
                onClick={() => onClickNumber('090')}
                disabled={!!value.length}
              >
                090
              </button>
            </div>
          )}

          {/* Number pad */}
          <div className={styles.numberGrid}>
            <button
              className={styles.button}
              onClick={() => onClickNumber('1')}
              style={{ gridRow: 1, gridColumn: 1 }}
            >
              1
            </button>
            <button
              className={styles.button}
              onClick={() => onClickNumber('2')}
              style={{ gridRow: 1, gridColumn: 2 }}
            >
              2
            </button>
            <button
              className={styles.button}
              onClick={() => onClickNumber('3')}
              style={{ gridRow: 1, gridColumn: 3 }}
            >
              3
            </button>

            <button
              className={styles.button}
              onClick={() => onClickNumber('4')}
              style={{ gridRow: 2, gridColumn: 1 }}
            >
              4
            </button>
            <button
              className={styles.button}
              onClick={() => onClickNumber('5')}
              style={{ gridRow: 2, gridColumn: 2 }}
            >
              5
            </button>
            <button
              className={styles.button}
              onClick={() => onClickNumber('6')}
              style={{ gridRow: 2, gridColumn: 3 }}
            >
              6
            </button>

            <button
              className={styles.button}
              onClick={() => onClickNumber('7')}
              style={{ gridRow: 3, gridColumn: 1 }}
            >
              7
            </button>
            <button
              className={styles.button}
              onClick={() => onClickNumber('8')}
              style={{ gridRow: 3, gridColumn: 2 }}
            >
              8
            </button>
            <button
              className={styles.button}
              onClick={() => onClickNumber('9')}
              style={{ gridRow: 3, gridColumn: 3 }}
            >
              9
            </button>
            <button
              className={styles.button}
              onClick={() => onClickNumber('0')}
              style={{ gridRow: 4, gridColumn: 2 }}
            >
              0
            </button>

            <button
              className={`${styles.button} ${styles.backspaceButton}`}
              onClick={onClickBackSpace}
            >
              一文字
              <br />
              消す
            </button>
            <button
              className={`${styles.button} ${canClickEnter ? styles.enterButton : styles.enterButtonDisabled}`}
              disabled={!canClickEnter}
              onClick={() => onClickEnter(value)}
            >
              決定
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(SpTelInput)
